import { Component, OnInit, Optional, Inject, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatDialog, MatPaginator } from '@angular/material';
import { MemberInfoService } from './service/member-info.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { ChangeOfRoleComponent } from '../change-of-role/change-of-role.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonHelper } from '../../../../utilities/common.helper';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from '../../../../shared/sharedServices/shared.service';


@Component({
  selector: 'kt-thematic-panel-info-modal',
  templateUrl: './thematic-panel-info-modal.component.html',
  styleUrls: ['./thematic-panel-info-modal.component.scss'],
  providers: [MemberInfoService]
})
export class ThematicPanelInfoModalComponent implements OnInit {

  public form: FormGroup;
  public isDataPresent: boolean = true
  public memberInfo:any = null
  public pageState:string = null
  public panelNameToShow:string = null
  public minorSubjectToShow:string = null
  public majorSubjectToShow:string = null
  public dropdownMajor:any = null
  public loggedUserType:string = null
  public filteredMajors: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();

  public dataSource = new MatTableDataSource<any>(this.memberInfo);
  public displayedColumns: string[] = ['grantConfigName', 'panelName', 'panelType', 'role'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor( private dialogRef: MatDialogRef<ThematicPanelInfoModalComponent>,
    private memberInfoService:MemberInfoService ,
    private sharedService: SharedService,
    private cdr:ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialog: MatDialog,
    private fb: FormBuilder,) { }
    // @HostListener('window:keyup.esc') onKeyUp() {
    //   this.dialogRef.close();
    // }
  ngOnInit() {
    console.log(this.data)
    this.pageState = this.data.pageState
    console.log(this.pageState)

    
    
    
   
    if(this.pageState){
      if(this.pageState != 'Project Assignment'){
        this.panelNameToShow = this.data.panelData.panelName
        this.minorSubjectToShow = this.data.newRow.minorSubject     
      }
      this.createForm(this.data)
      this.getMajorList()
      this.getMemberInfo()

      if(this.pageState){
        if(this.pageState == 'Project Assignment'){
          this.form.controls.majorSubjectId.disable()
          this.minorSubjectToShow = this.data.newRow.minorSubject ? this.data.newRow.minorSubject  : null
          this.majorSubjectToShow = this.data.newRow.majorSubject ? this.data.newRow.majorSubject : null
    
        }
      }
    }
    console.log(this.paginator)


    this.loggedUserType = localStorage.getItem('LOGGED_USER_TYPE')
  }

  public onButtonClick(button?) {
    this.dialogRef.close(button);
  }

  private createForm(data): void {
    this.form = this.fb.group({
    
      majorSubjectId:[data.newRow.majorSubjectId ? data.newRow.majorSubjectId : null],
      minorSubject:[data.newRow.minorSubject ? data.newRow.minorSubject : null],
      majorFilter:[null]

    })
  }

  public getMemberInfo(): void {


    let email = null
    let isInvited = null
    if(this.pageState == 'Project Assignment'){
       email = this.data.newRow.reviewerEmail ? this.data.newRow.reviewerEmail : null
       isInvited = false
    }
    else{
       email = this.data.newRow.email ? this.data.newRow.email : null
       isInvited = this.data.newRow.isInvited ?  this.data.newRow.isInvited : null
    }
  

    this.isDataPresent = false
    this.memberInfoService.getMemberInfo(isInvited,email).subscribe(response => {
      this.isDataPresent = true
      if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
        if (response['data']) {

          this.memberInfo = response['data'];
          this.dataSource = new MatTableDataSource<any>(response['data'][0].rgaMemberDetailListDto);
          this.dataSource.paginator = this.paginator;
          // this.dataSource.paginator.length = response['data'][0].rgaMemberDetailListDto.length;
          this.cdr.detectChanges();
        }
      }
       else if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND) {
        this.sharedService.showError(response['statusDescription'], 'OK', 'error-snackbar');
      }
      else if (+response['statusCode'] == HEC_CONSTANTS.HTTP_RESPONSE.SEARCH_COUNT_LIMIT_VIOLATED) {
        this.sharedService.showError(response['statusDescription'], 'OK', 'error-snackbar');
      } 
      else {
        this.sharedService.showError('Something went wrong', 'OK', 'error-snackbar');
      }
    }, 
    (err) => {
      this.isDataPresent = true
      this.sharedService.showError('something went wrong', 'OK', 'error-snackbar');
    })

  }

  private getMajorList() {
    this.sharedService.getMajorList().subscribe(response => {
      if (response) {
        this.dropdownMajor = response['data']
        this.filteredMajors.next(this.dropdownMajor.slice());
        this.form.controls.majorFilter.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterMajors();
        });
      }
      else{
        this.dropdownMajor = []
      }
    })
  }

  protected filterMajors() {
    if (!this.dropdownMajor) {
      return;
    }
    // get the search keyword
    let search = this.form.controls.majorFilter.value;
    if (!search) {
      this.filteredMajors.next(this.dropdownMajor.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredMajors.next(
      this.dropdownMajor.filter(member => (
        
        (member.label ? member.label.toLowerCase().indexOf(search) > -1 : null))))
  }


  public changeOfRole(eachRow):void{
    this.changeRole(this.data.panelData,this.data.newRow,this.data.panelMemberIndex)
  }

  public showPanelIcon(row):boolean{
    return (row.panelName == this.data.newRow.panelName)
  }


  public changeRole(data, item, panelMemberIndex): void {
    console.log(item, panelMemberIndex)
    const dialogRef = this.matDialog.open(ChangeOfRoleComponent, {
      width: '80vw',
      height: '80vh',
      // backdropClass: 'km-smallpopuptiny',
      panelClass: 'km-smallpopuptiny',
      // disableClose: true,
      autoFocus: false,
      data: {
        panelData: data,
        newRow: item,
        panelMemberIndex:panelMemberIndex,
        pageState: this.pageState

      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.dialogRef.close(result)
        // data.rgaRoleViewDtoList.splice(panelMemberIndex, 1);
        // data.rgaRoleViewDtoList.splice(panelMemberIndex, 0, result.payload.rgaRoleViewDtoList[0]);
        // this.cdr.detectChanges()
      }


    });

  }


  private markFormsTouched(): void {
    CommonHelper.markFormGroupTouched(this.form);
  }

  private formValid(payload): boolean {
    return this.form.valid && payload.rgaRoleViewDtoList.length > 0
  }

  private constructPayloadOthers() {   
    let payload = {
        addNewMember:true,
        addMajorMinorSubject:true,
        panelId:this.data.panelData.panelId ? this.data.panelData.panelId : null,
        panelName:this.data.panelData.panelName ? this.data.panelData.panelName : null,
        rgaRoleViewDtoList: [this.data.newRow]
    }
    payload.rgaRoleViewDtoList[0].majorSubjectId = this.form.value.majorSubjectId 

    if(this.form.value.majorSubjectId){  
      payload.rgaRoleViewDtoList[0].majorSubject =  (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[0].majorSubjectId).label
    }
    else{
      payload.rgaRoleViewDtoList[0].majorSubject = ""
    }
    if(this.form.value.minorSubject){
      payload.rgaRoleViewDtoList[0].minorSubject = this.form.value.minorSubject

    }
    return payload;
  }

  private constructPayloadTypeTwo() {   
    let payload = {
        addMajorMinorSubject:true,
        rgaRoleViewDtoList: [this.data.newRow]
    }

    if(this.form.value.majorSubjectId){
      payload.rgaRoleViewDtoList[0].majorSubjectId = this.form.value.majorSubjectId 
      payload.rgaRoleViewDtoList[0].majorSubject =  (this.dropdownMajor as any).find((v: any) => v.value ==  payload.rgaRoleViewDtoList[0].majorSubjectId).label
    }
    if(this.form.value.minorSubject){
      payload.rgaRoleViewDtoList[0].minorSubject = this.form.value.minorSubject

    }
    return payload;
  }

  public updateMajorMinorSubject():void{
    if(this.pageState == 'JMP' || this.pageState == 'HLEP' || this.pageState == 'Steering Committee'){
      this.updateMajorMinorSubjectTypeTwo()
    }
    else{
      this.updateMajorMinorSubjectTypeOne()
    }
  }


  
  private updateMajorMinorSubjectTypeTwo(): void {
    this.markFormsTouched();
    let payload = this.constructPayloadTypeTwo()
    if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    if (payload && payload.rgaRoleViewDtoList) {
      if (payload.rgaRoleViewDtoList[0].isInvited && payload.rgaRoleViewDtoList[0].isInvited == true) {
        this.isTypeTwoInvitationNotAccepted(payload, this.pageState)
      }
      else {
        this.isTypeTwoInvitationAccepted(payload, this.pageState)
      }
    }
    else {
      this.isDataPresent = true
    }

  }

  private updateMajorMinorSubjectTypeOne():void{
    this.markFormsTouched();
    let payload = this.constructPayloadOthers()
    if (!this.formValid(payload))
    return;
  this.isDataPresent = false
  if(payload && payload.rgaRoleViewDtoList){
    if(payload.rgaRoleViewDtoList[0].isInvited && payload.rgaRoleViewDtoList[0].isInvited == true)
    {
      this.isInvitationNotAccepted(payload)
    }
    else{
  this.isInvitationAccepted(payload)
    }
  }
  else{
    this.isDataPresent = true
  }

  }

  private isInvitationAccepted(payload):void{
    this.sharedService.saveNewMemberDetails(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == 401) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } else {
        }
      }
    )

  }

  private isTypeTwoInvitationAccepted(payload,pageState):void{
    this.sharedService.updateMajorMinorSubjectsInvitationAccepted(payload,pageState)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == 401) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } else {
        }
      }
    )

  }

  private isInvitationNotAccepted(payload):void{
    this.sharedService.addAndInviteMember(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == 401) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } else {
        }
      }
    )

  }

  private isTypeTwoInvitationNotAccepted(payload,pageState):void{
    this.sharedService.updateMajorMinorSubjectsInvitationNotAccepted(payload,pageState)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode != HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
        else {
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == 401) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } else {
        }
      }
    )

  }
}
